import { uploadFile } from '@acme/common'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
    CreateFaltaCadastradaSchema,
    FaltaCadastrada,
    faltasCadastradas,
} from 'service/api/endpoints/faltas-cadastradas'
import { toast } from 'sonner'
import { useStore } from 'store'
import { LancamentosAnterioresAsync } from 'templates/ManutencaoDoPonto/Ausencias/lancamentos-anteriores'
import { useUpdateDigitacaoQueryData } from 'templates/ManutencaoDoPonto/Digitacao/pages/useDigitacaoData'
import FormEditarFaltaCadastrada from '../forms/EditarFaltaCadastrada'

const baseUrl = import.meta.env.VITE_BASE_URL

export default function NovaFaltaCadastradaDigitacao() {
    const { dia } = useParams()
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const { mutateAsync } = faltasCadastradas.mutations.useCreate()
    const isInjustificada = pathname.includes('falta-injustificada')

    if (!dia) navigate(-1)

    const empresaId = useStore(state => state.companyId)
    const funcionarioId = useStore(state => state.employeeId)

    const handleSubmit: SubmitHandler<
        FaltaCadastrada & { isInjustificada?: boolean }
    > = async ({ fileUrl, ...input }) => {
        if (input.isInjustificada) {
            delete input.justificativa
            fileUrl = null
        }

        const filename =
            (await uploadFile(fileUrl, baseUrl).catch(e => {
                toast.error(e.data?.message || e.message)
                return null
            })) || null
        await mutateAsync(
            { ...input, funcionarioId, empresaId, fileUrl: filename },
            {
                onSuccess: payload => {
                    setQueryData('FALTA_CADASTRADA', payload)
                    toast.success(
                        `Falta ${
                            input.justificativa
                                ? 'justificada'
                                : 'injustificada'
                        } criada com sucesso`,
                    )
                },
                onError: e => {
                    toast.error(e.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            height="auto"
            width="45rem"
            onSubmit={handleSubmit}
            defaultValues={{
                data: dia,
                isInjustificada,
            }}
            schema={CreateFaltaCadastradaSchema}
            open={hasPermission([
                'create',
                'FaltasJustificadasOuInjustificadas',
            ])}
        >
            <Dialog.Title>Registrar falta</Dialog.Title>
            <Dialog.Content dividers>
                <FormEditarFaltaCadastrada />
                <LancamentosAnterioresAsync
                    tipoAusencia={
                        isInjustificada
                            ? 'Falta injustificada'
                            : 'Falta justificada'
                    }
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
